import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import Swal from "sweetalert2";

import {
  User,
  Discussion,
  PanelMember,
  MembershipListConfig,
} from "../../../../shared";

@Component({
  selector: "discussion-meta-section",
  templateUrl: "./discussion-meta-section.component.html",
  styleUrls: [
    "./discussion-meta-section.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DiscussionMetaSectionComponent implements OnInit {
  private defaultUserImg: string =
    "../../../../assets/images/uMuzi/african-mask.png";
  private defaultCommunityImg: string =
    "../../../../assets/images/uMuzi/hut.png";
  public config: MembershipListConfig = new MembershipListConfig();

  @Input() discussion: Discussion;
  @Input() currentUser: User;
  @Input() canModifyDiscussion: boolean;
  @Input() currentPanelMember: PanelMember;

  constructor() {}

  ngOnInit() {}

  public joinDiscussionPanelAlert() {
    Swal.fire({
      title: "Eish!",
      text: "Joining the nDaba panels are invite only, please ask the author of the nDaba to invite you",
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Mxm, ok!",
    });
  }
}
